import { Editor } from "@tiptap/core";

export const removeAllCommentMarks = (editor: Editor | null) => {
  if (!editor) return;

  editor.commands.command(({ tr, state }) => {
    const { doc, schema } = state;
    const markType = schema.marks.commentMark;

    doc.descendants((node, pos) => {
      if (!node.isText) return;

      const hasMark = markType.isInSet(node.marks);
      if (hasMark) {
        tr.removeMark(pos, pos + node.nodeSize, markType);
      }
    });

    return true;
  });
};

export const removePersistentCommentMark = (editor: Editor | null, commentId: string) => {
  if (!editor) return;

  const { schema } = editor.state;
  const markType = schema.marks.persistentCommentMark;

  if (!markType) return;

  editor.commands.command(({ tr, state, dispatch }) => {
    const { doc, schema } = state;
    const markType = schema.marks.persistentCommentMark;

    if (!markType) return false;

    let hasChanges = false;
    doc.descendants((node, pos) => {
      if (!node.isText) return;

      const mark = markType.isInSet(node.marks);
      if (mark && mark.attrs.commentId === commentId) {
        tr.removeMark(pos, pos + node.nodeSize, markType);
        hasChanges = true;
      }
    });

    if (hasChanges && dispatch) {
      tr.setMeta("addToHistory", false);
      dispatch(tr);
    }

    return hasChanges;
  });
};
